import React, { useEffect, useState } from 'react';

import { formatFigure } from 'Helpers/formatService';

export default function GeneralRevenuesTable({ fetchUrl }) {
    const [isLoading, setIsLoading] = useState(true);
    const [revenues, setRevenues] = useState([]);

    useEffect(() => {
        fetchTicketingRevenueCommitment();
    }, []);

    const fetchTicketingRevenueCommitment = () => {
        setIsLoading(true);

        axios
            .get(fetchUrl)
            .then(({ data }) => {
                setRevenues(data);
            })
            .catch((e) => {
                console.error(e);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    return (
        <div className="table__card">
            <h3 className="table__header tw-mb-6">{$t('Revenue Commitment')}</h3>
            <div className="inbud-table_wrapper">
                <table className="inbud-table">
                    <thead>
                        <tr>
                            <th>{$t('Department/Costcenter')}</th>
                            <th>{$t('Name')}</th>
                            <th>{$t('Total')}</th>
                            <th>{$t('Committed')}</th>
                            <th>{$t('Uncommitted')}</th>
                            <th
                                data-toggle="tooltip"
                                data-placement="bottom"
                                title={$t('Anticipated Final Revenue (AFR) is equal to total revenue plus specific risks minus specific opportunities')}
                            >
                                {$t('AFR')}
                                <i className="fas fa-info-circle pl-1 text-secondary"></i>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {isLoading && (
                            <tr>
                                <td colSpan={10}>
                                    <div
                                        className="spinner-border"
                                        style={{
                                            width: '2rem',
                                            height: '2rem',
                                        }}
                                        role="status"
                                    >
                                        <span className="sr-only">{$t('Loading')}...</span>
                                    </div>
                                </td>
                            </tr>
                        )}

                        {!isLoading &&
                            !!revenues?.length &&
                            revenues.map((revenue) => (
                                <tr key={_.snakeCase(`${revenue.depcc}_${revenue.name}`)}>
                                    <td>{revenue.depcc}</td>
                                    <td>{revenue.name}</td>
                                    <td className="tw-text-right">{formatFigure(revenue.total)}</td>
                                    <td className="tw-text-right">{formatFigure(revenue.committed)}</td>
                                    <td className="tw-text-right">{formatFigure(revenue.uncommitted)}</td>
                                    <td className="tw-text-right">{formatFigure(revenue.afr)}</td>
                                </tr>
                            ))}

                        {!isLoading && !revenues?.length && (
                            <tr>
                                <td colSpan={10}>{$t('No committed revenues')}</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
